<h3 class="top-padding">學校政策</h3>
<div style="text-align: left;">
  <a routerLink="../">返回</a>
</div>
<hr>

<ng-container *ngFor='let document of guidanceDocs'>
  <a href="{{ document.url }}" target='_blank' class="noUnderline">
    <div class="homeCard"> {{ document.name }} </div>
  </a>
</ng-container>
